// Customer-set dispositions (the client decides what happens to each returned item).
export const DISPOSITIONS = [
  { value: "restock", label: "Restock", hint: "Back to sellable stock", icon: "PackageCheck", cls: "bg-emerald-100 text-emerald-700 border-emerald-300", active: "bg-emerald-600 text-white border-emerald-600" },
  { value: "damage", label: "Damage", hint: "Not sellable", icon: "PackageX", cls: "bg-amber-100 text-amber-800 border-amber-300", active: "bg-amber-500 text-white border-amber-500" },
  { value: "donate", label: "Donate", hint: "Give to charity", icon: "HandHeart", cls: "bg-violet-100 text-violet-700 border-violet-300", active: "bg-violet-600 text-white border-violet-600" },
  { value: "dispose", label: "Dispose", hint: "Trash / recycle", icon: "Trash2", cls: "bg-red-100 text-red-700 border-red-300", active: "bg-red-600 text-white border-red-600" },
  { value: "hold", label: "Hold", hint: "Keep aside for now", icon: "PauseCircle", cls: "bg-slate-100 text-slate-700 border-slate-300", active: "bg-slate-700 text-white border-slate-700" },
  { value: "send_back", label: "Send back to customer", hint: "Re-ship to the buyer", icon: "Send", cls: "bg-blue-100 text-blue-700 border-blue-300", active: "bg-blue-600 text-white border-blue-600" },
];

export const DISPOSITION_META = DISPOSITIONS.reduce((m, d) => { m[d.value] = d; return m; }, {});
// Legacy labels for older records.
const LEGACY = { damaged: "Damaged", reusable: "Reusable" };
export const DISPOSITION_LABEL = (v) => DISPOSITION_META[v]?.label || LEGACY[v] || (v || "").replace(/_/g, " ");

// Staff-recorded condition observations — multi-select, no default. Big touch tiles.
export const CONDITION_TAGS = [
  { value: "dirty", label: "Dirty", icon: "Droplets" },
  { value: "stained", label: "Stained", icon: "Paintbrush" },
  { value: "wrinkled", label: "Wrinkled", icon: "Waves" },
  { value: "ripped", label: "Ripped", icon: "Scissors" },
  { value: "stretched_out", label: "Stretched out", icon: "MoveHorizontal" },
  { value: "smelly", label: "Smelly", icon: "Wind" },
  { value: "no_bag", label: "No bag", icon: "PackageX" },
  { value: "no_tags", label: "No tags", icon: "Tag" },
  { value: "worn", label: "Worn", icon: "Shirt" },
  { value: "like_new", label: "Like new", icon: "Sparkles" },
];

export const CONDITION_META = CONDITION_TAGS.reduce((m, t) => { m[t.value] = t; return m; }, {});
export const CONDITION_LABEL = (v) => CONDITION_META[v]?.label || (v || "").replace(/_/g, " ");

export const RETURN_REASONS = [
  "Changed mind",
  "Wrong item",
  "Damaged / defective",
  "Didn't fit",
  "Arrived late",
  "No longer needed",
  "Other",
];
